import React, {useEffect, useState} from 'react';
import {Form, Grid, Header, Segment, Table} from 'semantic-ui-react';
import {toast} from "react-toastify";
import {useLoaderData, useLocation, useNavigate} from "react-router-dom";
import useBonusConfigService from "../../../../../services/backoffice/hooks/useBonusConfigService";
import {ToasterConfig} from "../../../../../config/ToasterConfig";
import {EditBonusConfigRequest} from "../../../../../models/requests/edit-bonus-config-request";
import {useBlockUI} from "../../../../../shared/services/block-ui-service";

export async function editBonusConfigLoader({params}: any) {
    return params.id;
}

const EditBonusConfigPage = () => {
    const [bonusConfig, setBonusConfig] = useState<Partial<EditBonusConfigRequest>>({});
    const navigate = useNavigate();
    const {editBonusConfig, getBonusConfigById} = useBonusConfigService();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const fleetId = params.get('fleetId');
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const loader: any = useLoaderData();
    const blockUI = useBlockUI();
    useEffect(() => {
        const bonusConfigId = loader;
        if (!bonusConfigId) return;
        getBonusConfigById(bonusConfigId).then((response: any) => {
            setBonusConfig(response)
        })
    }, [loader])
    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    const updateBonusConfig = async () => {
        try {
            setLoading(true);
            if (bonusConfig) {
                const result = await editBonusConfig({
                    ...bonusConfig
                }, bonusConfig.id);
                if (!!result) {
                    navigate('/backoffice/fleets/bonus-configs/?operationId=' + fleetId);
                    toast.success('Faixa de premiação atualizada com sucesso', ToasterConfig.success);
                }
            }
        } catch (error: any) {
            setLoading(false);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Grid.Column mobile={16} tablet={8} computer={6}>
                <Header as="h3" textAlign="center" color={'green'}>
                    Faixa de Premiação / Editar
                </Header>
                <Segment>
                    <Form onSubmit={updateBonusConfig}>
                        <Form.Input
                            label={'Mínimo de Performance da Premiação (%)'}
                            name="minPerformance"
                            type="number"
                            step="0.01"
                            placeholder="Mínimo de Performance da Premiação (%)"
                            value={bonusConfig.minPerformance}
                            onChange={(event) => setBonusConfig({...bonusConfig, minPerformance: event.target.valueAsNumber})}

                            required
                        />

                        <Form.Input
                            label={'Máximo de Performance da Premiação (%)'}
                            name="maxPerformance"
                            type="number"
                            step="0.01"
                            placeholder="Máximo de Performance da Premiação (%)"
                            value={bonusConfig.maxPerformance}
                            onChange={(event) => setBonusConfig({...bonusConfig, maxPerformance: event.target.valueAsNumber})}
                            required
                        />

                        <Form.Input
                            label={'Valor da Premiação (R$)'}
                            name="bonusValue"
                            type="number"
                            step="0.01"
                            placeholder="Valor da Premiação"
                            value={bonusConfig.bonusValue}
                            onChange={(event) => setBonusConfig({...bonusConfig, bonusValue: event.target.valueAsNumber})}
                            required
                        />

                        <Table.Row>
                            <Table.HeaderCell>
                                <Form.Button content="Voltar"
                                             icon='arrow left'
                                             onClick={() => navigate('/backoffice/fleets/bonus-configs/?operationId=' + fleetId)}
                                             grey/>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Form.Button content="Adicionar"
                                             type={"submit"}
                                             icon='save'
                                             color={"green"}/>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Form>
                </Segment>
            </Grid.Column>
        </div>
    );
};

export default EditBonusConfigPage;
